export const KIOSK_CONCIERGE_ROLLOUT_FLAG = 'ecomm.concierge.kiosk.rollout';
